export default __webpack_public_path__ + "static/media/share-android.c78447c210d8025f5eecb940a7389973.svg";